import { render, staticRenderFns } from "./InformacaoContratoNovo.vue?vue&type=template&id=610a1516"
import script from "./InformacaoContratoNovo.vue?vue&type=script&lang=js"
export * from "./InformacaoContratoNovo.vue?vue&type=script&lang=js"
import style0 from "./InformacaoContratoNovo.vue?vue&type=style&index=0&id=610a1516&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports